import { api } from '@/scripts/api'

export type TagResponse = {
  id: number
  name: string
  description?: string
  color?: string
  is_active: boolean
  created_at: string
  updated_at?: string
}

export type TagListResponse = {
  tags: TagResponse[]
  total: number
  page: number
  page_size: number
}

export type TagCreate = {
  name: string
  description?: string
  color?: string
  is_active?: boolean
}

export type TagUpdate = {
  name?: string
  description?: string
  color?: string
  is_active?: boolean
}

export class TagService {
  /**
   * 获取标签列表
   */
  static async getTags(
    params: {
      page?: number
      page_size?: number
      is_active?: boolean
      search?: string
    } = {}
  ): Promise<TagListResponse> {
    const searchParams = new URLSearchParams()

    if (params.page) searchParams.append('page', params.page.toString())
    if (params.page_size)
      searchParams.append('page_size', params.page_size.toString())
    if (params.is_active !== undefined)
      searchParams.append('is_active', params.is_active.toString())
    if (params.search) searchParams.append('search', params.search)

    const response = await api.fetchApi(`/tags/?${searchParams}`)

    if (!response.ok) {
      throw new Error(`获取标签列表失败: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * 获取所有启用的标签
   */
  static async getActiveTags(): Promise<TagResponse[]> {
    const response = await api.fetchApi('/tags/active')

    if (!response.ok) {
      throw new Error(`获取启用标签失败: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * 创建标签
   */
  static async createTag(tagData: TagCreate): Promise<TagResponse> {
    const response = await api.fetchApi('/tags/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(tagData)
    })

    if (!response.ok) {
      throw new Error(`创建标签失败: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * 获取标签详情
   */
  static async getTag(tagId: number): Promise<TagResponse> {
    const response = await api.fetchApi(`/tags/${tagId}`)

    if (!response.ok) {
      throw new Error(`获取标签详情失败: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * 更新标签
   */
  static async updateTag(
    tagId: number,
    tagData: TagUpdate
  ): Promise<TagResponse> {
    const response = await api.fetchApi(`/tags/${tagId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(tagData)
    })

    if (!response.ok) {
      throw new Error(`更新标签失败: ${response.statusText}`)
    }

    return response.json()
  }

  /**
   * 删除标签
   */
  static async deleteTag(tagId: number): Promise<void> {
    const response = await api.fetchApi(`/tags/${tagId}`, {
      method: 'DELETE'
    })

    if (!response.ok) {
      throw new Error(`删除标签失败: ${response.statusText}`)
    }
  }
}
